<script setup lang="ts">
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import { useAppStore } from '@/stores/app'
import Loading from '@/components/common/Loading.vue'
import ClaroTag from './components/GoogleTag/ClaroTag.vue'
import HtechTag from './components/GoogleTag/HtechTag.vue'
import GTagCodes from './shared/constants/GTagCodes'
import SpriteLoader from './components/logos/SpriteLoader.vue'

const appStore = useAppStore()
const claroGoogleTagId = computed(() => GTagCodes.claro[appStore.country].code)
const htechGoogleTagId = computed(() => GTagCodes.htech[appStore.country].code)
</script>

<template>
  <SpriteLoader />
  <RouterView />
  <Loading v-if="appStore.isLoading || appStore.persistLoading" />
  <ClaroTag :google-tag-id="claroGoogleTagId" />
  <HtechTag :google-tag-id="htechGoogleTagId" />
</template>
